import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Heading from '../../Components/heading.tsx';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'; 

const styles = {
    header: {
        marginTop: '30px',
      },
    statusContainer: {
    paddingBottom: '16px',
    borderRadius: '8px',
    width: '100%',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  launchingSoonText: {
    textAlign: 'center',
    fontSize: '50px',
    color: '#18bdde',
    marginTop:'250px'
  },
};

const RoutesScreen: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const vehicleId = params.get('vehicle_id');
  const token = params.get('token');
  const userId = params.get('user_id');
  const userName = params.get('user_name') || '';
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(`/wv/dashboard?user_name=${userName}&vehicle_id=${vehicleId}&user_id=${userId}&token=${token}`);
  }

  return (
    <Container style={styles.container}>
    <Box style={styles.header}>
      <Heading title="Routes" onBackClick={handleBack} />
    </Box>
    <Box style={styles.statusContainer}>
      <Typography style={styles.launchingSoonText}>
        Launching Soon
      </Typography>
    </Box>
  </Container>
  );
};

export default RoutesScreen;
